export default __webpack_public_path__ + "static/media/correct.7ced05d3.svg";